<template>
  <div v-if="isShow">
    <div class="bg_white mt25">
      <Pageback :backLinkName="'salonSchedule'" />
      <h2 class="detail_title ab">{{ title }}</h2>

      <dl>
        <div class="">
          <p class="schedule_time rb">{{ scheduleDateTime }}</p>
        </div>
        <div v-for="val in detail" class="">
          <dt v-if="val.header" v-html="val.header">{{ val.header }}</dt>
          <dd v-if="val.body" v-html="val.body">{{ val.body }}</dd>
        </div>
      </dl>
    </div>
  </div>
  <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
</template>

<script>
import Check from '@/model/getToken'
import json from '@/assets/test.json';
import CalendarApi from '@/components/api/calendar'
import Pageback from '@/components/common/Pageback';

export default {
  components: {
    Pageback
  },
  data() {
    return {
      isShow: true,
      title: '',
      detail: [],
      scheduleDateTime: null,
    }
  },
  methods: {
    initialized() {
      this.title = '';
      this.detail = [];
      this.scheduleDateTime = null;
    },
    async apiGetCalendarDetail(calendarId) {
      await CalendarApi.getCalendarDetail(calendarId).then((val) => {
        console.log(val);
        this.title = val.title;
        this.detail.push(...val.calendarScheduleDetailList);
        this.scheduleDateTime = val.scheduleDateTime;
      });
    },
    backPage() {
      console.log('back');
    }
  },
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      // API追加後に記述
      this.initialized();
      this.apiGetCalendarDetail(this.$route.query.id);
    } else {
      this.isShow = false;
    }


  }
}
</script>

<style lang="css" scoped>
.detail_title {
  border-left: 5px solid  #4FCCD4;
  font-size: 16px;
  margin: 12px 16px 0;
  padding-left: 5px;
}

.schedule_time {
  font-size: 17px;
}

dl {
  margin-top: 45px;
}
dl div {
  margin: 0 16px;
}
dt {
  /* border-top: 1px solid  #c9c9c9; */
  font-weight: 400;
  font-family: 'Almarai', sans-serif;
  color: #878787;
  font-size: 12px;
  padding-top: 19px;
}

div {
  color: #5a5a5a;
  font-weight: 700;
  font-family: 'Almarai', sans-serif;
  font-size: 16px;
  padding-bottom: 10px;
}
dl div:not(:last-child) {
  border-bottom: 1px solid  #c9c9c9;
}
>>> iframe {
  height: auto!important;
  margin-top: 5px!important;
  width: 100%!important;
}
</style>



// WEBPACK FOOTER //
// src/views/salon/ScheduleDetail.vue